import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
export var Title = function (props) {
    return (React.createElement(Typography, { component: "h2", variant: "h6", color: "primary", gutterBottom: true }, props.children));
};
Title.propTypes = {
    children: PropTypes.node,
};
